import React, { Component } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import FormCobroServicioAlumno from "./FormCobroServicioAlumno";
import { getAlumnoDetail, putAlumnoCobro, putAlumnoCobroServicio } from "./AlumnoAction";
import swal from "sweetalert";
import { withRouter } from 'react-router-dom';

import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import { Link } from "react-router-dom";

import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import ToolTip from "../../common/toolTip";

import DownloadIcon from '@mui/icons-material/Download';


const mapStateToProps = (state) => {
    return {
        getResponDataAlumno: state.AlumnoReducer.getResponDataAlumno,
        errorResponDataAlumno: state.AlumnoReducer.errorResponDataAlumno,
    };
};


class AlumnoCobroServicioContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
            show: false,
            isCardRemove: false,
            isFullScreen: false,
            isCollapsed: false,
            isCollapsed2: false,
            detalleAlumno: [],
            loadingDetalleAlumno:true,
            detalleColegiatura: [],
            loadingDetalleColegiatura: true,
            detalleHermanoAlumno: [],
            loadingDetalleHermanoAlumno: true,
            detallPagoAlumno: [],
            loadingDetallePagoAlumno: true,
		};
	}

    componentDidMount() {
        this.props.dispatch(getAlumnoDetail(this.props.match.params.id));
        this.populateDetalleAlumno(this.props.match.params.id);
        this.populateDetalleColegiatura(this.props.match.params.id);
        this.populateHermanosAlumno(this.props.match.params.id);
        this.populateDetallePagoAlumno(this.props.match.params.id);
    }

    handleSubmit(data) {
        this.props.dispatch(putAlumnoCobroServicio(data, this.props.match.params.id));
    }


    static renderDetalleAlumno(detalleAlumno) {
        //console.log("javier-->"+detalleAlumno.length);

        return (
            <div className="card">
                <div className="card-body w_user">
                    {
                        detalleAlumno.map(detalleAlumno =>
                            <>
                            <div className="user_avtar">
                                    {detalleAlumno.sexo == "Femenino" ? <img className="rounded-circle" src="../assets/images/sm/avatar5.jpg" alt="" /> : <img className="rounded-circle" src="../assets/images/sm/avatar4.jpg" alt="" />}
                            </div>
                            <div className="wid-u-info">
                                <h5>{detalleAlumno.nombres} {detalleAlumno.apellidopaterno} {detalleAlumno.apellidomaterno}</h5>
                                <p className="text-muted m-b-0">{detalleAlumno.colonia} {detalleAlumno.calle} #{detalleAlumno.numero} C.P {detalleAlumno.codigopostal} Tel. {detalleAlumno.telefono}</p>
                                <ul className="list-unstyled">
                                    <li>
                                        <small className="mb-0" style={{ fontWeight: "bold" }}> Hermanos </small> <span><br></br> </span>
                                        <small> {detalleAlumno.totalhermanos}</small>
                                    </li>
                                    <li>
                                        <small className="mb-0" style={{ fontWeight: "bold" }}> Tutor </small> <span><br></br> </span>
                                        <small> {detalleAlumno.nombretutor}</small>
                                    </li>
                                    <li>
                                        <small className="mb-0" style={{ fontWeight: "bold" }}> Fecha Nacimiento </small> <span><br></br> </span>
                                        <small> {detalleAlumno.fechanacimiento}</small>
                                    </li>
                                </ul>
                            </div>
                            </>
                        )
                    }

                </div>
            </div>
        );

    }//END METHOD

    static renderDetalleAlumno2(detalleAlumno) {
        return (
            <>
            {
                detalleAlumno.map(detalleAlumno =>
                    <>
                        <li className="list-group-item">
                            <b>Nivel </b>
                            <div style={{ fontWeight: "bold" }}>{detalleAlumno.nivel}</div>
                        </li>
                        <li className="list-group-item">
                            <b>Grado </b>
                            <div style={{ fontWeight: "bold" }}>{detalleAlumno.nivel2}</div>
                        </li>
                        <li className="list-group-item">
                            <b>Grupo </b>
                            <div style={{ fontWeight: "bold" }}>{detalleAlumno.grupo}</div>
                        </li>             
                    </>
                )
            }
            </>
        );

    }//END METHOD

    static renderColegiaturaAlumno2(detalleColegiatura) {

        return (
            <>
                {
                    detalleColegiatura.map(detalleColegiatura =>
                        <>
                            <div className="timeline_item ">
                                {detalleColegiatura.sexo == "Femenino" ? <img className="tl_avatar" src="../assets/images/xs/avatar1.jpg" alt="" /> : <img className="tl_avatar" src="../assets/images/xs/avatar4.jpg" alt="" />}
                                <span>Servicio Pagado: {detalleColegiatura.conceptocobro} <small className="float-right text-right">{detalleColegiatura.fechapago} - Cobro</small></span>
                                <h6 className="font600">{detalleColegiatura.preciocatalogo} | {detalleColegiatura.precio}</h6>
                                {detalleColegiatura.ruta != "" ? <a onClick={() => window.location.href = '/api/Alumno/BajarFormatoCobroColegiaturaServicioPorId?id=' + detalleColegiatura.idservicio + "&tipo=SERVICIO"}><DownloadIcon color="primary" /></a>: ""}
                            </div>
                        </>
                    )
                }
            </>
        );

    }//END METHOD

    static renderHermanoAlumno(detalleHermanoAlumno) {

        return (
            <>
                {
                    detalleHermanoAlumno.map(detalleHermanoAlumno =>
                        
                        <li className="list-group-item" key={detalleHermanoAlumno.idalumno}>
                            <b>{detalleHermanoAlumno.sexo == "Femenino" ? "Hermana" : "Hermano"}</b>
                            <div>{detalleHermanoAlumno.nombres} {detalleHermanoAlumno.apellidopaterno} {detalleHermanoAlumno.apellidomaterno}</div>
                        </li>
                    )
                }
            </>
        );


    }

	render() {
		const { activeTab } = this.state
        const { dropDownMenu, dropDownMenuAction } = this.props
        const { isCardRemove, isFullScreen, isCollapsed, isCollapsed2 } = this.state

		if (this.props.getResponDataAlumno || this.props.errorResponDataAlumno) {

            if (this.props.errorResponDataAlumno) {
                swal("Fallido!", this.props.errorResponDataAlumno, "Error");
            } else {
				swal({
					title: "¡Cobro Servicio Generado!",
					icon: "success",
					button:"Enterado"
					}
                )
                .then((willDelete) => {
					this.props.history.push("/alumno");
                });
			}//END ELSE

        }//END IF

        let contentsDetalleAlumno = this.state.loadingDetalleAlumno ? <p><em>Cargando Información Alumno...</em></p> : AlumnoCobroServicioContainer.renderDetalleAlumno(this.state.detalleAlumno);
        let contentsDetalleAlumno2 = this.state.loadingDetalleAlumno ? <p><em>Cargando Información Alumno...</em></p> : AlumnoCobroServicioContainer.renderDetalleAlumno2(this.state.detalleAlumno);

        let contentsDetalleColegiatura = this.state.loadingDetalleColegiatura ? <p><em>Cargando meses pagados...</em></p> : AlumnoCobroServicioContainer.renderColegiaturaAlumno2(this.state.detalleColegiatura);

        let contentsDetalleHermanoAlumno = this.state.loadingDetalleHermanoAlumno ? <p><em>Cargando hermanos...</em></p> : AlumnoCobroServicioContainer.renderHermanoAlumno(this.state.detalleHermanoAlumno);
        
            

		return (
			<MuiThemeProvider muiTheme={getMuiTheme()}>
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Alumno</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Escolar</a></li>
									<li className="breadcrumb-item active" aria-current="page">Cobro</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/alumno"}>Listar Alumno</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

					

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>
							<TabPane tabId={1} className={classnames(['fade show'])}>

                                    <div className="row">
                                        <div className="col-xl-4 col-md-12">

                                            {contentsDetalleAlumno}

                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed2 ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Sobre Mí</h3>
                                                    <div className="card-options ">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed2: !isCollapsed2 })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
                                                    </div>
                                                </div>

                                                <div className="card-body">
                                                    {
                                                        //<p>Hello I am Celena Anderson a Clerk in Xyz College USA. I love to work with all my college staff and seniour professors.</p>
                                                    }
                                                    <ul className="list-group">
                                                        {contentsDetalleAlumno2}

                                                        {contentsDetalleHermanoAlumno}
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-xl-8 col-md-12">
                                            <div className={`card ${isCardRemove ? 'card-remove' : ''} ${isFullScreen ? 'card-fullscreen' : ''} ${isCollapsed ? 'card-collapsed' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">Cronogroma De Pagos Servicios</h3>
                                                    <div className="card-options">
                                                        <a href="#" className="card-options-collapse" onClick={() => this.setState({ isCollapsed: !isCollapsed })}><i className="fe fe-chevron-up"></i></a>
                                                        <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen" onClick={() => this.setState({ isFullScreen: !isFullScreen })}><i className="fe fe-maximize"></i></a>
                                                        {
                                                            //<a href className="card-options-remove" onClick={() => this.setState({ isCardRemove: !isCardRemove })}><i className = "fe fe-x" ></i></a>
                                                        }
                                                       
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    
                                                    {contentsDetalleColegiatura}

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        /*
                                <FormCobroServicioAlumno onSubmit={(data) => this.handleSubmit(data)} />
                                */
                                    }

                                

							</TabPane>

							
						</TabContent>
					</div>
				</div>

					
			</>
			</MuiThemeProvider>
		);

    }// END RENDER


    async populateDetalleAlumno(id) {
        const response = await fetch('/api/Alumno/ObtieneAlumnoPorId?id='+id);
        const data = await response.json();
        this.setState({ detalleAlumno: data, loadingDetalleAlumno:false});
    }

    async populateDetalleColegiatura(id) {
        const response = await fetch('/api/AlumnoServicio/ObtieneServicioPorIdAlumno?id=' + id);
        const data = await response.json();
        this.setState({ detalleColegiatura: data, loadingDetalleColegiatura: false });
    }

    async populateHermanosAlumno(id) {
        const response = await fetch('/api/Alumno/ObtieneHermanosDelAlumno?id=' + id);
        const data = await response.json();
        this.setState({ detalleHermanoAlumno: data, loadingDetalleHermanoAlumno: false });
    }

    async populateDetallePagoAlumno(id) {
        const response = await fetch('/api/Alumno/ObtieneDatoPagoAlumno?idalumno=' + id);
        const data = await response.json();
        this.setState({ detallPagoAlumno: data, loadingDetallePagoAlumno: false });
    }

    


} //END 

export default withRouter(connect(mapStateToProps, null)(AlumnoCobroServicioContainer));
